// lib
import React from 'react';

// components
import KnowMore from 'shared/layouts/DetailsPage/components/ProductInfo/Desktop/components/EcomPolicy/components/KnowMore';

// styles
import { Card, EcomPolicyImage, EcomPolicyText } from './styles';

// helpers
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';

// def
interface ICard {
  image: string;
  text: string;
  enable?: boolean;
  alt?: string;
  policyName: string;
  onClick: (enable: boolean, name: string) => void;
}

function EcomPolicyCard({ image, text = "", enable = false, policyName, alt, onClick }: ICard) {
  return (
    <Card>
      <EcomPolicyImage src={image} alt={alt} />

      <EcomPolicyText
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(text.replace(/<b>/g, "<strong>").replace(/<\/b>/g, "</strong>")),
        }}
      />

      {enable && (
        <KnowMore
          onClick={() => {
            onClick(enable, policyName);
          }}
        />
      )}
    </Card>
  );
}

export default EcomPolicyCard;
